
















































































































































































































































































































































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  AlertMessage,
  bibliographyRealApi,
  BibliographyTooli,
  ErrorMessage
} from '@/api'
import {
  alertStore,
  modalErrorStore,
  systemParameterStore
} from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { AlertFactory } from '@/factory'
import { AlertCodeAL300048, AlertCodeALC00007 } from '@/types'
import { InputCode } from '@/components/molecules/InputCode'
import { setErrorMessage } from '@/utils/error'

@Component({
  components: { InputCode }
})
export default class BibliographyDetailTooliInfo extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: BibliographyTooli

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  downloadable!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isRegisteredBibliography!: boolean

  get cssCustomProperty(): any {
    return {
      '--height': this.height + 'px'
    }
  }

  get ndc(): string {
    return systemParameterStore.displayNdc(
      this.item.ndc8,
      this.item.ndc9,
      this.item.ndc10
    )
  }

  onClickDownload() {
    if (this.isRegisteredBibliography) {
      alertStore.setItem(AlertFactory.create(AlertCodeAL300048))
    } else {
      alertStore.setItem(AlertFactory.create(AlertCodeALC00007, 'MARC', '登録'))
    }

    this.$modalAlert.open({
      onOkClick: this.downloadBibliographyMarcTooli
    })
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  async downloadBibliographyMarcTooli(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographyRealApi.downloadBibliographyMarcTooli({
        marcNo: this.item.marcNo,
        materialFormat: this.item.inputMaterialFormat.input
      })
      this.$emit('updated')
    } catch (error) {
      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, {
          materialFormat: this.item.inputMaterialFormat
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
